//FUNCIONS
import React, { useCallback, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { StoreState } from '../../../../store/createStore';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';

//HOOKS
import { useAccount } from '../../hooks/hooksAccount';
import { useTranslation } from '../../../../hooks/useTranslation';

//TYPES
import { CustomerData } from '../../../../store/modules/auth/types';
//COMPONENTS

//STYLES
import { Container } from './styles';
import {
  Title,
  ContainerForm,
  FormLine,
  FormInputGroup,
  ContainerFooter,
  Button as ButtonDiv,
} from '../../styles';
import Button from '../../../../components/Button';
import { bValidCpf } from '../../../../utils/bValidCpf';
import { bValidBirthDay } from '../../../../utils/bValidBirthDay';
import { customerUpdateRequest } from '../../../../store/modules/auth/actions';
import getValidationErrors from '../../../../utils/getValidationErrors';
import Input from '../../../../components/Input';
import Loading from '../../../../components/Loading';
import { isAdult } from '../../../../utils/isAdult';

const AccountDataData: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { setOpenViewPassword, openViewPassword } = useAccount()
  const { loading, user: { data: customerData } } = useSelector((state: StoreState) => state.auth);
  const { onTranslation: t } = useTranslation();
  const dispatch = useDispatch();

  const handleSubmit = useCallback(
    async (customerDataProfile: CustomerData) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          first_name: Yup.string().required('Nome obrigatório'),
          last_name: Yup.string().required('Sobrenome obrigatório'),
          customer_id: Yup.string().transform((value: string) => {
            return value.split(/\D/).join('')
          }).test({
            test: customer_id => bValidCpf(customer_id),
            message: 'CPF inválido',
          }).required('CPF obrigatório'),
          date_of_birth: Yup.string()
            .transform((value: string) => value.split(/\D/).join(''))
            .test({
              test: birth => bValidBirthDay(birth),
              message: 'Data de nascimento inválida'
            })
            .min(6, 'Mínimo 6 dígitos')
            .max(8, 'Máximo 8 dígitos')
            .required('Data de nascimento obrigatória')
            .test('is-adult', 'Você deve ter pelo menos 18 anos', (birth) => isAdult(birth as string)),
          phone: Yup.string().transform((value: string) => {
            return value.split(/\D/).join('')
          }).matches(/^\d{2}\d{4,5}\d{4}$/gi,
            'Celular invalido (DD NNNN-NNNN)')
            .required('Celular obrigatório').test({
              test: phone_mobile => !isNaN(phone_mobile),
              message: 'Digite apenas números no celular'
            }),
          email: Yup.string()
            .required('E-mail obrigatório')
            .email('Digite um e-mail válido'),
        });

        await schema.validate(customerDataProfile, {
          abortEarly: false,
        });

        if (customerDataProfile.date_of_birth && customerDataProfile.date_of_birth.length > 0) {
          const date_of_birth = customerDataProfile.date_of_birth.split('/').reverse().join('-');
          customerDataProfile.date_of_birth = date_of_birth;
        }

        if (customerDataProfile.customer_id && customerDataProfile.customer_id.length > 0) {
          const customer_id = customerDataProfile.customer_id.split('.').join('').replace(/\s_/g, '');
          customerDataProfile.customer_id = customer_id;
        }

        const customerProfile = {} as CustomerData;
        if (customerDataProfile.email)
          customerProfile.email = customerDataProfile.email;
        if (customerDataProfile.first_name)
          customerProfile.first_name = customerDataProfile.first_name;
        if (customerDataProfile.last_name)
          customerProfile.last_name = customerDataProfile.last_name;
        if (customerDataProfile.new_password)
          customerProfile.new_password = customerDataProfile.new_password;
        if (customerDataProfile.new_password_confirmation)
          customerProfile.new_password_confirmation = customerDataProfile.new_password_confirmation;
        if (customerDataProfile.gender)
          customerProfile.gender = customerDataProfile.gender;
        if (customerDataProfile.date_of_birth)
          customerProfile.date_of_birth = customerDataProfile.date_of_birth.split(/\D/).join('');
        if (customerDataProfile.customer_id)
          customerProfile.customer_id = customerDataProfile.customer_id.split(/\D/).join('');
        if (customerDataProfile.phone)
          customerProfile.phone = customerDataProfile.phone.split(/\D/).join('');

        dispatch(customerUpdateRequest(customerProfile));
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
        }
      }
    }, [dispatch]);

  useEffect(() => {
    if (formRef.current && customerData) {
      formRef.current.setData({
        first_name: customerData.first_name,
        last_name: customerData.last_name,
        email: customerData.email,
        date_of_birth: customerData.date_of_birth,
        customer_id: customerData.customer_id,
        phone: customerData.phone,
      });
    }
    else {
      if (formRef.current) {
        formRef.current.setData({
          first_name: '',
          last_name: '',
          email: '',
          date_of_birth: '',
          customer_id: '',
          phone: '',
        });
      }
    }
  }, [customerData]);

  return (
    <Container>
      <Title>
        <span>{t('main.new_account.account_data.data_user')}</span>
      </Title>
      <ContainerForm>
        <Form
          // initialData={{ postcode: '06422070' }}
          ref={formRef}
          onSubmit={handleSubmit}
          style={{ width: "100%" }}
        >
          <FormInputGroup>
            <FormLine width="100%">
              <Input
                name="first_name"
                textLabel={`${t('main.new_account.account_data.input_name')}`}
                Border="1px solid var(--primary)"
                formRef={formRef}
              />
              {/* <FormInputTitle>{t('main.new_account.account_data.input_name')}</FormInputTitle>
              <FormInput
                name="first_name"
                onChange={handledChange}
                value={customerData.first_name}
              /> */}
            </FormLine>
            <FormLine>
              <Input
                name="last_name"
                textLabel={`${t('main.new_account.account_data.input_last_name')}`}
                Border="1px solid var(--primary)"
                formRef={formRef}
              />
              {/* <FormInputTitle>{t('main.new_account.account_data.input_last_name')}</FormInputTitle>
              <FormInput
                name="last_name"
                onChange={handledChange}
                value={customerData.last_name}
              /> */}
            </FormLine>
          </FormInputGroup>
          <FormInputGroup>
            <FormLine>
              <Input
                name="email"
                textLabel={`${t('main.new_account.account_data.input_email')}`}
                Border="1px solid var(--primary)"
                formRef={formRef}
              />
              {/* <FormInputTitle>{t('main.new_account.account_data.input_email')}</FormInputTitle>
              <FormInput
                name="email"
                onChange={handledChange}
                value={customerData.email}
              /> */}
            </FormLine>
            <FormLine>
              <Input
                textLabel={`${t('main.new_account.account_data.input_date_of_birth')}`}
                name="date_of_birth"
                mask="##/##/####"
                Border="1px solid var(--primary)"
                formRef={formRef}
              />
            </FormLine>
          </FormInputGroup>
          <FormInputGroup>
            <FormLine>
              <Input
                textLabel={`${t('main.new_account.account_data.input_cpf')}`}
                name="customer_id"
                Border="1px solid var(--primary)"
                mask="###.###.###-##"
                formRef={formRef}
                disabled
              />
            </FormLine>

            <FormLine>
              <Input
                name="phone"
                textLabel={`${t('main.new_account.account_data.input_phone')}`}
                Border="1px solid var(--primary)"
                mask="(##) #####-####"
                formRef={formRef}
              />
              {/* <FormInputTitle>{t('main.new_account.account_data.input_phone')}</FormInputTitle>
              <FormInput
                name="phone"
                onChange={handledChange}
                value={customerData.phone}
              /> */}
            </FormLine>
          </FormInputGroup>
          <ContainerFooter borderTop>
            <ButtonDiv typeStep='alert' onClick={() => setOpenViewPassword(!openViewPassword)}>
              <span>{t('main.new_account.account_data.change_password')}</span>
            </ButtonDiv>

            <ButtonDiv typeStep='success'>
              <Button
                button={{ type: 'submit' }}
                atributes={{
                  buttonType: 'success',
                  textColor: '#fff',
                  textSize: '18px',
                }}
              >
                {
                  loading ? (
                    <Loading size={20} />
                  ) : (
                    <span>{t('main.globals.save')}</span>
                  )
                }
              </Button>
            </ButtonDiv>
          </ContainerFooter>
        </Form >
      </ContainerForm>
    </Container>
  );
}

export default AccountDataData;
